@if (netPromoterScore; as score) {
  <glxy-badge [color]="npsScoreBadgeColor">
    {{ 'CONTACT.PROFILE_PAGE.NPS' | translate: { score: score } }}
  </glxy-badge>
}
